module.exports = __webpack_public_path__ + "img/Icon_user.05e06d58.svg";